<template>
  <div class="operate_panel">
    <!-- <keep-alive> -->
        <form v-show="isReplaySearch" style="height:40px;padding:0 10px;">
            <div class="operate_input" v-for="(ipt, ipti) in search.input" :key="ipti">
                <!-- <span>{{ipt.placeholder}}:</span> -->
                <input class="text_input" v-if="ipt.type === 'text'" type="text" @keyup.enter.stop="search.events.search" v-model.lazy.trim="ipt.value" :minlength="ipt.min" :maxlength="ipt.max" :placeholder="ipt.placeholder" :style="{width:ipt.width?ipt.width:'120px'}">
                <input class="text_input" v-if="ipt.type === 'number'" type="number" @keyup.enter.stop="search.events.search" v-model.lazy.trim="ipt.value" :minlength="ipt.min" :maxlength="ipt.max" :placeholder="ipt.placeholder" :style="{width:ipt.width?ipt.width:'120px'}">
                <el-select class="oper_select" v-if="ipt.type === 'select'" v-model="ipt.value" :style="{width:ipt.width?ipt.width:'120px'}" :placeholder="ipt.placeholder" size="mini"
                    @change="(val)=>{if(ipt.change){ipt.change(val)}}">
                    <el-option
                    v-for="opt in ipt.options"
                    :key="opt.id"
                    :label="opt[ipt.view] || opt.value || opt.label || opt.code"
                    :value="opt[ipt.key] || opt.code">
                    </el-option>
                </el-select>
                <el-date-picker class="oper_select" :style="{width:ipt.width}"
                    v-if="ipt.type === 'times'"
                    v-model="ipt.value"
                    :clearable="ipt.clear"
                    :type="ipt.date || 'daterange'"
                    :value-format="ipt.format || 'yyyy-MM-dd'"
                    :picker-options="ipt.disabledDate"
                    :default-time="ipt.defaultTime"
                    :placeholder="ipt.placeholder"
                    :range-separator="ipt.separator||'至'"
                    :start-placeholder="ipt.startPlaceholder||'开始时间'"
                    :end-placeholder="ipt.endPlaceholder||'结束时间'"
                    size="mini">
                </el-date-picker>
                <el-date-picker class="oper_select" :style="{width:ipt.width}"
                    v-if="ipt.type === 'week'"
                    v-model="ipt.value"
                    @change="(val)=>{if(ipt.change){ipt.change(val)}}"
                    :clearable="ipt.clear"
                    :type="ipt.date || 'week'"
                    :value-format="ipt.format || 'yyyy-MM-dd'"
                    :picker-options="ipt.disabledDate"
                    :default-time="ipt.defaultTime"
                    :placeholder="ipt.placeholder"
                    size="mini">
                </el-date-picker>
                <el-cascader v-if="ipt.type === 'cader'" style="padding-right:5px;" 
                    :style="{width:ipt.width?ipt.width:'200px'}"
                    size="mini"
                    :options="ipt.options"
                    v-model="ipt.value"
                    :change-on-select="true"
                    :props="ipt.props"
                    :placeholder="ipt.placeholder"
                    @change="(val)=>{if(ipt.change){ipt.change(val)}}">
                </el-cascader>
            </div>
            <div class="operate_input">
                <!-- <div class="my_button other_button" @click="search.events.search"><i class="button_icon" :style="{background:'url('+searchIcon+')'}"></i><span style="padding-left: 13px;">搜索</span></div> -->
                <el-button 
                    size="mini" 
                    icon="el-icon-search" 
                    type="primary" 
                    @click="search.events.search" 
                    style="margin-right: 10px;">搜索</el-button>
            </div>
            <div class="operate_input more_box" v-if="search.mores">
                <!-- <div class="my_button other_button" @click="toggleSearchMore"><i class="button_icon" :style="{background:'url('+detailSearchIcon+')'}"></i><span style="padding-left: 13px;">详细搜索</span></div> -->
                <el-button size="mini" type="primary" @click="toggleSearchMore" style="margin-right: 10px;">
                    <i class="el-icon--left more-search-btn"></i>详细搜索
                </el-button>
                <div class="search_more" v-show="showSearchMore">
                    <ul>
                        <li class="more_li" :style="{width:search.moresPadding}" v-for="(more, morei) in search.mores" :key="morei">
                            <span :style="{width:search.moresTitleWidth}">{{more.name}} :</span>
                            <div class="more_li_select">
                                <input class="text_input more_input" v-if="more.type === 'text'" type="text" v-model.lazy.trim="more.value" :minlength="more.min" :maxlength="more.max" :placeholder="more.placeholder" :style="{width:more.width?more.width:'150px'}">
                                <el-select class="select_box" :style="{width:more.width}"
                                    v-if="more.type === 'select'" 
                                    v-model="more.value" 
                                    clearable
                                    @change="(val)=>{if(more.change){more.change(val)}}"
                                    :placeholder="more.placeholder" size="mini">
                                    <el-option
                                        v-for="moreOpt in more.options"
                                        :key="moreOpt.id"
                                        :label="moreOpt[more.view] || moreOpt.value"
                                        :value="moreOpt[more.key] || moreOpt.field||moreOpt.code">
                                    </el-option>
                                </el-select>
                                <el-date-picker class="select_box" :style="{width:more.width}"
                                    v-if="more.type === 'times'"
                                    v-model="more.value"
                                    :clearable="more.clear"
                                    :type="more.date || 'daterange'"
                                    :value-format="more.format || 'yyyy-MM-dd'"
                                    :default-time="more.defaultTime"
                                    range-separator="至"
                                    :start-placeholder="more.startPlaceholder || '开始日期'"
                                    :end-placeholder="more.endPlaceholder || '结束日期'"
                                    size="mini">
                                </el-date-picker>
                                <el-cascader class="select_box" :style="{width:more.width}"
                                    v-if="more.type === 'address'"
                                    v-model="more.value"
                                    :options="options"
                                    @change="handleChange"
                                    size="mini">
                                </el-cascader>
                            </div>
                        </li>
                    </ul>
                    <div class="more_buttons">
                        <!-- <div class="my_button"  @click="search.events.search();searchMore()">确定</div> -->
                        <el-button
                            size="mini" 
                            type="primary"
                            @click="search.events.search();searchMore()">确定</el-button>
                        <!-- <div class="my_button" @click="toggleSearchMore" style="background-color:#fff; color:#606266; margin-left:20px;">取消</div> -->
                        <el-button 
                            plain
                            size="mini" 
                            type="primary"
                            @click="toggleSearchMore">取消</el-button>
                    </div>
                </div>
            </div>
            <div class="operate_button" v-if="search.events.clear">
                <el-button 
                    size="mini" 
                    icon="el-icon-delete" 
                    type="danger" 
                    plain 
                    @click="search.events.clear" 
                    style="margin-right: 10px;">清空</el-button>
                <!-- <div class="my_button clear_button" style="background-color:#fff;" @click="search.events.clear"><i class="button_icon" :style="{background:'url('+clearIcon+')'}"></i><span>清空</span></div> -->
            </div>
        </form>
        <!-- <span class="replay_search el-icon-caret-bottom" v-if="search.showReplay===false?search.showReplay:true" :class="isReplaySearch?'rotate':''" @click="replay"></span> -->
    <!-- </keep-alive> -->
  </div>
</template>

<script>
import Vuex from 'vuex'
export default {
  name: 'vOperatePanel',
  props: {
    search: {
      type: Object,
      default: function() {
        return {}
      }
    }
  },
  data() {
    return {
      showSearchMore: false,
      searchIcon: require('../assets/search.png'),
      detailSearchIcon: require('../assets/detail_search.png'),
      clearIcon: require('../assets/clear.png'),
      options: []
    }
  },
  mounted() {},
  watch: {},
  computed: {
    ...Vuex.mapState(['isReplaySearch'])
  },
  methods: {
    ...Vuex.mapActions({
      replayChange: 'setReplaySearch'
    }),
    toggleSearchMore() {
      this.showSearchMore = !this.showSearchMore
    },
    searchMore() {
      this.showSearchMore = !this.showSearchMore
    },
    handleChange(value) {},
    replay() {
      this.replayChange(!this.isReplaySearch)
    }
  }
}
</script>

<style scoped>
.more-search-btn {
  width: 12px;
  height: 12px;
  vertical-align: top;
  background: url('../assets/detail_search.png') center no-repeat;
}
.more_input {
  margin-top: 10px;
}
.operate_panel {
  position: relative;
}
.replay_search {
  display: inline-block;
  width: 20px;
  height: 20px;
  font-size: 16px;
  line-height: 20px;
  text-align: center;
  cursor: pointer;
  position: absolute;
  right: 0px;
  top: -22px;
  z-index: 998;
  border: 1px solid #e7e7e7;
  /* transition: all .3s; */
}
.rotate {
  transform: rotate(180deg);
  -ms-transform: rotate(180deg); /* IE 9 */
  -moz-transform: rotate(180deg); /* Firefox */
  -webkit-transform: rotate(180deg); /* Safari 和 Chrome */
  -o-transform: rotate(180deg); /* Opera */
}
.operate_input {
  padding-top: 5px;
  float: left;
}
/*.text_input{
    height: 26px;
    border: 1px solid #E7E7E7;
    border-radius: 2px;
    margin-right: 8px;
    padding-left: 10px;
    color: #606266;
}*/
.oper_select {
  margin-right: 8px;
}
.operate_button {
  padding-top: 5px;
  float: left;
}
.other_button {
  margin-right: 10px;
}
.more_box {
  position: relative;
}
.search_more {
  min-width: 170px;
  background-color: #fff;
  z-index: 999;
  position: absolute;
  right: 11px;
  top: 38px;
  border: 1px solid #d8d8d8;
  box-shadow: 3px 3px 5px #888888;
  animation: searchMoreShow 0.3s;
}
@keyframes searchMoreShow {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
.search_more > ul {
  padding: 15px;
}
.more_buttons {
  border-top: 1px solid #d8d8d8;
  height: 80px;
  line-height: 80px;
  text-align: center;
}
.more_li {
  height: 48px;
  position: relative;
  padding-left: 100px;
}
.more_li > span {
  display: inline-block;
  position: absolute;
  left: 0;
  top: 0;
  width: 90px;
  height: 48px;
  line-height: 48px;
  text-align: right;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.more_li_select {
  display: inline-block;
}
.select_box {
  min-width: 100px;
  margin-top: 11px;
}

.clear_button {
  border: 1px solid #ff0000;
}

.clear_button:hover {
  border: 1px solid #ff0000;
}
.clear_button > span {
  color: #737373;
  padding-left: 13px;
}
</style>



// WEBPACK FOOTER //
// src/components/operatePanel.vue